import HOME_TV_DATA from "./family_tv";
import HOME_FR_DATA from "./family_fr";
import HOME_WASH_DATA from "./family_wash";
import HOME_MAIN_DATA from "./family_main";

const data = [HOME_MAIN_DATA, HOME_TV_DATA, HOME_FR_DATA, HOME_WASH_DATA];
export default data;
